module.exports = __webpack_public_path__ + "88c69a0ae668592ebfc5d189f4370169.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/earrings-ruby-s.png
// module id = 2186
// module chunks = 0